import styled from 'styled-components';

import { Tabs as AtomTabs } from '@atom/tabs/tabs';

export const Tabs = styled(AtomTabs)`
  & .ant-tabs-content-holder {
    padding-top: 8px;
  }
`;
